import lazyLoading from './lazyLoading'

export default {
  name: 'Articles',
  system: 'articles',
  path: '/articles',
  meta: {
    auth: true,
    icon: 'fa-file-text-o',
    link: 'articles/index.vue',
    label: 'Articles'
  },
  component: lazyLoading('articles', true)
}
